/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionreplacesrunning2Inputs */

const en_actionreplacesrunning2 = /** @type {(inputs: Actionreplacesrunning2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new action ends the running one.`)
};

const de_actionreplacesrunning2 = /** @type {(inputs: Actionreplacesrunning2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine neue Aktion beendet die laufende.`)
};

/**
* | output |
* | --- |
* | "A new action ends the running one." |
*
* @param {Actionreplacesrunning2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionreplacesrunning2 = /** @type {((inputs?: Actionreplacesrunning2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionreplacesrunning2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionreplacesrunning2(inputs)
	return de_actionreplacesrunning2(inputs)
});
export { actionreplacesrunning2 as "actionReplacesRunning" }